import {useMediaQuery} from '@mui/material'
import moment from 'moment'
import React, {FC, useCallback, useMemo} from 'react'
import {useNavigate} from 'react-router-dom'
import {
  FavoriteButton,
  LikeButton,
  NotificationType,
  NotificationTypes,
  NotificationAvatarBadgeList,
  NotificationMessageTextList
} from 'entities/activity'
import {mediaVariants} from 'shared/lib'
import {Avatar} from 'shared/ui/avatar'
import styles from './styles.module.scss'

type NotificationItemProps = {
  notification: NotificationType
  className?: string
  isAction?: boolean
}

export const NotificationItem: FC<NotificationItemProps> = ({notification: {from, type, dateCreated}, isAction, className}) => {
  const navigate = useNavigate()
  const is768p = useMediaQuery(`(max-width: ${styles.is768p})`)
  const is1280p = useMediaQuery(`(max-width: ${styles.is1280p})`)

  const openProfile = useCallback(() => navigate(`/profile/${from.id}`), [navigate, from.id])

  const isLargeAvatar = useMemo(() => (isAction && is768p) || (!isAction && is1280p), [isAction, is768p, is1280p])

  if (
    type !== NotificationTypes.LIKE &&
    type !== NotificationTypes.FAVORITE &&
    type !== NotificationTypes.MATCH &&
    type !== NotificationTypes.VISIT &&
    type !== NotificationTypes.POSSIBLE_MATCH
  ) return <></>

  return (
    <div className={`${styles.notificationItem} ${className}`} onClick={openProfile}>
      <div className={styles.avatar}>
        <Avatar sx={isLargeAvatar ? {width: 52, height: 52} : {}} src={from.avatarUrl + mediaVariants.square64} alt={from.name} />
        <AvatarBadge isLargeAvatar={isLargeAvatar} type={type as NotificationTypes} />
      </div>
      <div className={`${styles.profileInfo} ${isAction || !is1280p ? styles.border : ''}`}>
        <div className={styles.info}>
          <div className={styles.firstLine}>
            <span className={styles.name}>
              {from.name}
            </span>
            <span className={styles.type}>
              {NotificationMessageTextList[type as NotificationTypes]}
            </span>
          </div>
          <div className={styles.time}>
            {moment(dateCreated).format(`D MMM`)} at {moment(dateCreated).format('h:mm a')}
          </div>
        </div>

        {isAction && !is768p ? <div className={styles.actions}>
          <LikeButton className={styles.button} value={Boolean(from.connection?.likeTime)} idUser={from.id} />
          <FavoriteButton className={styles.button} value={Boolean(from.connection?.favoriteTime)} idUser={from.id} />
        </div> : null}
      </div>
    </div>
  )
}

const AvatarBadge: React.FC<{type: NotificationTypes, isLargeAvatar: boolean}> = ({isLargeAvatar, type}) => {
  return (
    <div className={`${styles.circle} ${styles[type]} ${isLargeAvatar ? styles.large : ''}`}>
      {NotificationAvatarBadgeList[type]}
    </div>
  )
}